import uInput from "./u-Input";
import Checkbox from "./checkbox";
import Tree from "./tree";
import Modal from "./modal";
// import FaultType from "./selection-box/fault-type";
import Location from "./location";
import chooseCustomer from "./choose-customer";
import MyHomeCloudCustomer from "./my-home-cloud-customer";
// import uModal from "./u-Modal";
import uTable from "./u-Table";
import uDropdown from "./u-Dropdown";
import NoData from "./no-data";
import personnel from "./selection-box/personnel";
import uPage from "./page/page";
import CellBar from "./cell-bar";
import uDatePicker from "./u-DatePicker";
import ChooseDevice from "./choose-device";
import ChooseMateriel from "./choose-materiel";
import Vue from "vue";

// import checkboxButton from "./checkboxButton/index"
const components = {
    uInput,
    uCheckbox: Checkbox,
    uTree: Tree,
    uModal: Modal,
    // FaultType,
    // FaultTypeRadio: FaultType.radio,
    Location,
    chooseCustomer,
    personnel,
    CellBar,
    MyHomeCloudCustomer,
    NoData,
    uTable,
    uDropdown,
    uPage,
    uDatePicker,
    ChooseDevice,
    ChooseMateriel
};
Object.keys(components).forEach(key => {
    Vue.component(key, components[key]);
});

Vue.prototype.$personnel = personnel;
Vue.prototype.$uModal = Modal;
// for (let i = 0; i < components.length; i++) {
//   Vue.component(components[i].name, components[i]);
// }
